var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-sheet', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "480"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center text-h3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.userTypeText) + " 회원가입 ")]), _c('v-card-text', [_c('join-form', _vm._b({}, 'join-form', {
    code: _vm.code,
    skin: _vm.code
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }